import * as React from 'react'
import { render } from 'react-dom'

import { authUser } from './core/services/auth.service'
import App from './views'
import { dataLayer } from './views/_utils/adobeAnalytics/adobeAnalytics.conf'
import history from './views/_utils/history'
import { changeLanguageFromURL } from './views/_utils/i18next'

const mountPoint = document.getElementById('root') as HTMLElement

changeLanguageFromURL()
authUser()

history.listen(location => {
  dataLayer.page.pageInfo.previousPage = {
    pageName: dataLayer.page.pageInfo.pageName,
  }
  dataLayer.page.pageInfo.pageName = location.pathname
})

render(<App />, mountPoint)

if (module.hot) {
  module.hot.accept('./views', () => {
    const NextApp = require('./views').default
    render(<NextApp />, mountPoint)
  })
}
